import { z } from "zod";
const sentryTraceDataSchema = z.object({
  ["sentry-trace"]: z.string().optional(),
  baggage: z.string().optional()
}).optional();
function buildLangfuseUserIdForCompany(values) {
  return `company_${values.companyId}`;
}
function buildTracingUserIdForInterviewApp(values) {
  return `contact_${values.contactId}`;
}
export {
  buildLangfuseUserIdForCompany,
  buildTracingUserIdForInterviewApp,
  sentryTraceDataSchema
};
//# sourceMappingURL=tracing.js.map
